import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));

// sample page routing
// const SamplePage = Loadable(lazy(() => import('views/sample-page')));
const NoHomologados = Loadable(lazy(() => import('views/pages/homologaciones/NoHomologados')));
const Homologados = Loadable(lazy(() => import('views/pages/homologaciones/Homologados')));
const HomologadosMT = Loadable(lazy(() => import('views/pages/homologaciones/HomologadosMT')));
const NoHomologadosMT = Loadable(lazy(() => import('views/pages/homologaciones/NoHomologadosMT')));
const MaestroTiendas = Loadable(lazy(() => import('views/pages/maestro/MaestroTiendas')));
const MaestroTiendasMT = Loadable(lazy(() => import('views/pages/maestro/MaestroTiendasMT')));
const AsignacionTiendas = Loadable(lazy(() => import('views/pages/maestro/AsignacionTiendas')));
// const Maestro = Loadable(lazy(() => import('views/pages/maestro/MaestroProductos')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: 'homologaciones/homologados',
            element: <Homologados />
        },
        {
            path: 'homologaciones/no-homologados',
            element: <NoHomologados />
        },
        {
            path: 'homologaciones/homologadosmt',
            element: <HomologadosMT />
        },
        {
            path: 'homologaciones/no-homologadosmt',
            element: <NoHomologadosMT />
        },
        {
            path: 'maestros/productos',
            element: <MaestroTiendas />
        },
        {
            path: 'maestros/productosmt',
            element: <MaestroTiendasMT />
        }
    ]
};

export default MainRoutes;
